import { Link } from 'react-router-dom'

import { Button, SettingsIcon } from '@buffer-mono/popcorn'

import { useAccountId } from '~publish/contexts/AccountContext'

import type { JSX } from 'react'

function ManageChannelAccessCTA(): JSX.Element | null {
  const accountId = useAccountId()

  if (!accountId) {
    return null
  }

  return (
    <Button
      variant="secondary"
      size="medium"
      as={Link}
      to={`/settings/team#/team-members/${accountId}`}
    >
      <SettingsIcon /> Manage Channel Access
    </Button>
  )
}

export default ManageChannelAccessCTA
